import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import classes from '../../../pipeline.module.scss';
import Api from '../../../../../../../api/api';
import Table from '../../../../../../_common/Tables/Table';
import Chip from '../../../../../../_common/Chip/Chip';
import StatusField from '../../../../../../_common/StatusField/StatusField';
import { Card } from '../../PipelineComponents';
import { formattedCount, formattedDate } from '../../../pipelineHelpers';

const tableHeader = [
  { name: 'Member', path: 'name' },
  { name: 'Rx', path: 'rxNumber' },
  {
    name: 'Type',
    path: 'type',
    render: (d) => (d.type
      ? (
        <div className={classes.chip_wrapper}>
          <Chip text={d.type} gray />
        </div>
      )
      : '-'),
  },
  { name: 'Trigger', path: 'trigger' },
  { name: 'Action taken', path: 'actionTaken' },
  {
    name: 'Outcome',
    path: 'outcome',
    render: (d) => (d.outcome ? <StatusField status={d.outcome} /> : '-'),
  },
  { name: 'Pharmacist', path: 'pharmacist' },
  { name: 'Date', path: 'interventionDate' },
];

const limit = 10;

const InterventionsLogCard = ({ params }) => {
  const navigate = useNavigate();

  const firstLoad = useRef(true);

  const [logData, setLogData] = useState([]);
  const [total, setTotal] = useState(0);
  const [loading, loadingToggle] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        loadingToggle(true);

        const { data } = await Api.getInterventions({ ...params, limit });

        setLogData((data?.data?.response || []).map((d) => ({
          ...d,
          id: d.PatientId,
          name: [d.Patient?.firstName, d.Patient?.lastName].filter(Boolean).join(' '),
          rxNumber: d.Script?.rxNumber,
          pharmacist: d.Pharmacist?.name,
          interventionDate: formattedDate(d.interventionDate),
        })));

        setTotal(data?.data?._meta?.total);

        loadingToggle(false);
        firstLoad.current = false;
      } catch (e) {
        console.warn(e);
      }
    })();
  }, [params]);

  return (
    <Card
      title="Intervention log"
      caption={`Pharmacist actions in the period - ${formattedCount(total)} rows, first ${limit}`}
      loading={loading}
      firstLoad={firstLoad.current}
      isEmpty={!logData.length}
    >
      <div className={`${classes.pipeline_table} ${classes.bordered}`}>
        <Table
          header={tableHeader}
          data={logData}
          className={classes.clickable_row}
          onClick={(patientId) => navigate(`/patients/${patientId}`)}
        />
      </div>

      <p className={classes.note}>
        <span className={`${classes.badge} ${classes.badge_new}`}>new table</span>

        {' '}

        Interventions are clinical actions and stay separate from the pipeline in section 03 - a
        member can have both, linked by member and optionally by script.
      </p>
    </Card>
  );
};

InterventionsLogCard.propTypes = {
  params: PropTypes.object.isRequired,
};

export default InterventionsLogCard;
